import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { COURSE_SERIES_CONFIG } from './index';
import KPOPEPhysicsLinks from './data/Links.json';
import ReactGA from 'react-ga4';
import './LibraryCatalog.css';

const LibraryCatalog = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  // Filter series based on search
  const filteredSeries = COURSE_SERIES_CONFIG.filter((series) =>
    series.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const getSeriesCount = (data) => data.length;

  const getHeaderColor = (headerStyle) => {
    const colors = {
      'first-bar': '#FFF7E8',
      'right-bar': '#DCF9E2',
      'purple-bar': '#C0CBFA',
    };
    return colors[headerStyle] || '#DCF9E2';
  };

  return (
    <Container fluid className="library-catalog">
      {/* Header Section */}
      <div className="library-header">
        <h1 className="library-title">KPOPE Digital Library</h1>
        <p className="library-subtitle">
          The Korea Pragmatist Organization for Physics Education
        </p>
      </div>

      {/* Quick Links */}
      <div className="quick-links-section">
        <div className="quick-links-grid">
          <a
            href={KPOPEPhysicsLinks.subscribe_link}
            target="_blank"
            rel="noopener noreferrer"
            className="quick-link-card"
            onClick={() => ReactGA.event({
              name: 'youtube_click',
              params: { category: 'Button Clicks', action: 'click', label: 'KPOPE Youtube' },
            })}
          >
            <div className="quick-link-icon">📺</div>
            <div className="quick-link-text">
              <strong>Free KPOPE Lectures</strong>
              <small>YouTube Channel</small>
            </div>
          </a>
          <a
            href={KPOPEPhysicsLinks.orchid_link}
            target="_blank"
            rel="noopener noreferrer"
            className="quick-link-card"
          >
            <div className="quick-link-icon">📚</div>
            <div className="quick-link-text">
              <strong>Publication List</strong>
              <small>Research Papers</small>
            </div>
          </a>
          <a
            href={KPOPEPhysicsLinks.kpope_naver_cafe_link}
            target="_blank"
            rel="noopener noreferrer"
            className="quick-link-card"
          >
            <div className="quick-link-icon">💬</div>
            <div className="quick-link-text">
              <strong>KPOPE Classroom</strong>
              <small>Naver Cafe</small>
            </div>
          </a>
          <a
            href={KPOPEPhysicsLinks.inpsire_link}
            target="_blank"
            rel="noopener noreferrer"
            className="quick-link-card"
            onClick={() => ReactGA.event({
              name: 'inspire_click',
              params: { category: 'Button Clicks', action: 'click', label: 'INSPIRE HEP' },
            })}
          >
            <div className="quick-link-icon">🔬</div>
            <div className="quick-link-text">
              <strong>INSPIRE HEP</strong>
              <small>Particle Physics Papers</small>
            </div>
          </a>
          <a
            href={KPOPEPhysicsLinks.quarkvalley_link}
            target="_blank"
            rel="noopener noreferrer"
            className="quick-link-card"
            onClick={() => ReactGA.event({
              name: 'quarkvalley_click',
              params: { category: 'Button Clicks', action: 'click', label: 'Quark Valley Camp' },
            })}
          >
            <div className="quick-link-icon">🏕️</div>
            <div className="quick-link-text">
              <strong>Quark Valley</strong>
              <small>Physics Camp</small>
            </div>
          </a>
        </div>
      </div>

      {/* Search Bar */}
      <div className="search-section">
        <InputGroup size="lg">
          <InputGroup.Text>🔍</InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Search course series..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </InputGroup>
      </div>

      {/* Series Grid */}
      <div className="series-grid-section">
        <h2 className="section-title">Course Series</h2>
        <Row className="g-4">
          {filteredSeries.map((series) => (
            <Col key={series.id} xs={12} sm={6} lg={4} xl={3}>
              <Card
                className="series-card h-100"
                onClick={() => navigate(`/series/${series.slug}`)}
                style={{ cursor: 'pointer' }}
              >
                <Card.Header
                  style={{
                    backgroundColor: getHeaderColor(series.headerStyle),
                    borderBottom: 'none',
                  }}
                >
                  <div className="series-card-header">
                    <h5 className="series-card-title">{series.title}</h5>
                    <span className="series-count-badge">
                      {getSeriesCount(series.data)} lectures
                    </span>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="series-card-body">
                    <p className="series-description">
                      Browse {getSeriesCount(series.data)} lectures in this series
                    </p>
                  </div>
                </Card.Body>
                <Card.Footer className="series-card-footer">
                  <span className="view-series-link">View Series →</span>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
        {filteredSeries.length === 0 && (
          <div className="no-results">
            <p>No series found matching "{searchQuery}"</p>
          </div>
        )}
      </div>
    </Container>
  );
};

export default LibraryCatalog;

